import { Episode, EpisodeParticipantRole } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'

export const isActiveParticipantForEpisode = (
  episode: Pick<Episode, 'participants'> | undefined,
  lyraId: string | undefined,
  role: EpisodeParticipantRole,
) =>
  !!lyraId &&
  !!episode?.participants?.some(
    (participant) =>
      participant.role === role &&
      participant.participant_lyra_id === lyraId &&
      participant.status.toLowerCase() === 'active',
  )

/** The provider's own episode, or one where they are an active care-team member. */
export const isProviderEpisode = (episode: Episode, providerLyraId: string | undefined) =>
  episode.provider_id === providerLyraId ||
  isActiveParticipantForEpisode(episode, providerLyraId, EpisodeParticipantRole.CARE_TEAM_PROVIDER)

/** The provider's episodes, owned ones first so they win over care-team episodes when picking the first active one. */
export const getProviderEpisodes = (episodes: Episode[], providerLyraId: string | undefined) => [
  ...episodes.filter((episode) => episode.provider_id === providerLyraId),
  ...episodes.filter(
    (episode) =>
      episode.provider_id !== providerLyraId &&
      isActiveParticipantForEpisode(episode, providerLyraId, EpisodeParticipantRole.CARE_TEAM_PROVIDER),
  ),
]
